import { createAction, props } from "@ngrx/store";

const prefix = "[Consultant Skill Proficiency Filter]";

export const loadComponent = createAction(`${prefix} Load Component`);
export const unloadComponent = createAction(`${prefix} Unload Component`);
export const setFilter = createAction(
  `${prefix} Set Filter`,
  props<{ min: number; max: number }>(),
);
